import FlatFee from "../../entities/flatFee";

/**
 * FlatFee actions
 *
 * Call order:
 *
 * FLATFEE_SAVE_QUEUE:	adds the item to the save queue
 * --> FLATFEE_SAVE:	modifies the state
 * --> FLATFEE_SAVE_SUCCESS: if all went well
 * --> FLATFEE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail FLATFEE_SAVE_QUEUE is during the call to FLATFEE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const FLATFEE_FETCH_ONE_QUEUE: any = 'FLATFEE_FETCH_ONE_QUEUE';
export const FLATFEE_FETCH_SUCCESS: any = 'FLATFEE_FETCH_SUCCESS';
export const FLATFEE_FETCH_FAILURE: any = 'FLATFEE_FETCH_FAILURE';
export const FLATFEE_FETCH_ONE_SUCCESS: any = 'FLATFEE_FETCH_ONE_SUCCESS';
export const FLATFEE_FETCH_ONE_FAILURE: any = 'FLATFEE_FETCH_ONE_FAILURE';

export const FLATFEE_SAVE: any = 'FLATFEE_SAVE';
export const FLATFEE_SAVE_QUEUE: any = 'FLATFEE_SAVE_QUEUE';
export const FLATFEE_SAVE_SUCCESS: any = 'FLATFEE_SAVE_SUCCESS';
export const FLATFEE_SAVE_FAILURE: any = 'FLATFEE_SAVE_FAILURE';

export const FLATFEE_SAVE_MANY: any = 'FLATFEE_SAVE_MANY';
export const FLATFEE_SAVE_MANY_QUEUE: any = 'FLATFEE_SAVE_MANY_QUEUE';
export const FLATFEE_SAVE_MANY_SUCCESS: any = 'FLATFEE_SAVE_MANY_SUCCESS';
export const FLATFEE_SAVE_MANY_FAILURE: any = 'FLATFEE_SAVE_MANY_FAILURE';

export const FLATFEE_REMOVE: any = 'FLATFEE_REMOVE';
export const FLATFEE_REMOVE_QUEUE: any = 'FLATFEE_REMOVE_QUEUE';
export const FLATFEE_REMOVE_SUCCESS: any = 'FLATFEE_REMOVE_SUCCESS';
export const FLATFEE_REMOVE_FAILURE: any = 'FLATFEE_REMOVE_FAILURE';

export const FLATFEE_RESTORE: any = 'FLATFEE_RESTORE';
export const FLATFEE_RESTORE_QUEUE: any = 'FLATFEE_RESTORE_QUEUE';
export const FLATFEE_RESTORE_SUCCESS: any = 'FLATFEE_RESTORE_SUCCESS';
export const FLATFEE_RESTORE_FAILURE: any = 'FLATFEE_RESTORE_FAILURE';

export const FLATFEE_RESTORE_MANY: any = 'FLATFEE_RESTORE_MANY';
export const FLATFEE_REMOVE_MANY: any = 'FLATFEE_REMOVE_MANY';

/* Fetch actions */
export const fetchFlatFeeSuccess = (flatFees: FlatFee[], partial: boolean, lastFetch: number) => ({type: FLATFEE_FETCH_SUCCESS, flatFees, partial, lastFetch});
export const fetchFlatFeeFailure = (err: any) => {
		console.error('FlatFeeAction: fetchFlatFeeFailure', err);
		return {type: FLATFEE_FETCH_FAILURE, err};
};
export const fetchOneFlatFeeQueue = (flatFeeId: string) => ({type: FLATFEE_FETCH_ONE_QUEUE, flatFeeId});
export const fetchOneFlatFeeSuccess = (flatFee: FlatFee) => ({type: FLATFEE_FETCH_ONE_SUCCESS, flatFee});
export const fetchOneFlatFeeFailure = (id: string, err: any) => {
		console.error('FlatFeeAction: fetchOneFlatFeeFailure', err);
		return {type: FLATFEE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveFlatFee = (flatFee: FlatFee) => {
    // console.debug('⮂ FLATFEE_SAVE action', flatFee?.id);
    return {type: FLATFEE_SAVE, flatFee};
}
export const saveFlatFeeQueue = (flatFee: FlatFee) => {
    // console.debug('⮂ FLATFEE_SAVE_QUEUE action', flatFee?.id);
    return {type: FLATFEE_SAVE_QUEUE, flatFee};
}
export const saveFlatFeeSuccess = (flatFee: FlatFee) => {
    // console.debug('⮂ FLATFEE_SAVE_SUCCESS action', flatFee?.id);
    return {type: FLATFEE_SAVE_SUCCESS, flatFee};
}
export const saveFlatFeeFailure = (flatFee: FlatFee, status: number, message: string) => {
    console.warn(`⮂ FLATFEE_SAVE_FAILURE error saving flatFee: HTTP ${status}: ${message}`, flatFee?.id);
    return {type: FLATFEE_SAVE_FAILURE, flatFee, status, message};
};

/* SaveMany actions */
export const saveManyFlatFees = (flatFees: FlatFee[]) => {
    // console.debug('⮂ FLATFEE_SAVE_MANY action', flatFees?.map(flatFee => flatFee?.id).join(','));
    return {type: FLATFEE_SAVE_MANY, flatFees};
}
export const saveManyFlatFeesQueue = (flatFees: FlatFee[]) => {
    // console.debug('⮂ FLATFEE_SAVE_MANY_QUEUE action', flatFees?.map(flatFee => flatFee.id).join(','));
    return {type: FLATFEE_SAVE_MANY_QUEUE, flatFees};
}

export const saveManyFlatFeesSuccess = (flatFees: FlatFee[]) => {
    // console.debug('⮂ FLATFEE_SAVE_MANY_SUCCESS action', flatFees?.map(flatFee => flatFee.id).join(','));
    return {type: FLATFEE_SAVE_MANY_SUCCESS, flatFees};
}
export const saveManyFlatFeesFailure = (flatFees: FlatFee[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_FLATFEES_FAILURE Error saving flatFees: HTTP ${status}: ${message}`, flatFees?.map(flatFee => flatFee.id).join(','));
		return {type: FLATFEE_SAVE_MANY_FAILURE, flatFees, status, message};
};

/* Remove actions */
export const removeFlatFee = (flatFee: FlatFee) => ({ type: FLATFEE_REMOVE, flatFee });
export const removeFlatFeeQueue = (flatFee: FlatFee) => ({ type: FLATFEE_REMOVE_QUEUE, flatFee });
export const removeFlatFeeSuccess = (flatFee: FlatFee) => ({ type: FLATFEE_REMOVE_SUCCESS, flatFee });
export const removeFlatFeeFailure = (flatFee: FlatFee, status: number, message: string) => {
	console.error(`Redux: removeFlatFeeFailure Error removing flatFee: HTTP ${status}: ${message}`);
	return ({ type: FLATFEE_REMOVE_FAILURE, flatFee, status, message });
};

/* Restore actions */
export const restoreFlatFee = (flatFee: FlatFee) => ({ type: FLATFEE_RESTORE, flatFee });
export const restoreFlatFeeQueue = (flatFee: FlatFee) => ({ type: FLATFEE_RESTORE_QUEUE, flatFee });
export const restoreFlatFeeSuccess = (flatFee: FlatFee) => ({ type: FLATFEE_RESTORE_SUCCESS, flatFee });
export const restoreFlatFeeFailure = (flatFee: FlatFee, status: number, message: string) => {
	console.error(`Redux: restoreFlatFeeFailure Error restoring flatFee: HTTP ${status}: ${message}`);
	return ({ type: FLATFEE_RESTORE_FAILURE, flatFee, status, message });
};

/* RestoreMany actions */
export const restoreManyFlatFees = (flatFees: FlatFee[]) => ({ type: FLATFEE_RESTORE_MANY, flatFees });

/* RemoveMany actions */
export const removeManyFlatFees = (flatFees: FlatFee[]) => ({ type: FLATFEE_REMOVE_MANY, flatFees });